
<template>
    <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
    </div>
</template>
  
<script>
  export default {
    name: 'LoadingOverlay',
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
    },
  };
</script>
<style scoped>
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .spinner {
        border: 16px solid #f3f3f3;
        border-top: 16px solid #3498db;
        border-radius: 50%;
        width: 50px;
        height: 50px;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    } 
</style>
  